import { CustomDataTable } from '@/components/common';
import { type ProductRoadmapWithProduct } from '@/domain/products/types';
import { type RoadmapListDetail } from '@/domain/roadmap/types';
import { useAuth } from '@/hooks/useAuth';
import { Column } from 'primereact/column';

import DeleteRoadmapButton from '../DeleteRoadmapButton';
import EditRoadmapButton from '../EditRoadmapButton';

import type { JSX } from "react";

type RoadmapTableProps = {
  children: JSX.Element | JSX.Element[];
  roadMaps: Array<ProductRoadmapWithProduct | RoadmapListDetail>;
  isLoading?: boolean;
  onSaveCallback?: () => void;
  onDeleteCallback?: () => void;
};

const RoadmapTable = ({
  children,
  roadMaps,
  onSaveCallback,
  onDeleteCallback,
  isLoading = false,
}: RoadmapTableProps) => {
  const { isLoggedIn } = useAuth();

  const actionBodyTemplate = (rowData: ProductRoadmapWithProduct) => (
    <div className="actions">
      <EditRoadmapButton roadmap={rowData} onSaveCallback={onSaveCallback} />
      <DeleteRoadmapButton roadmap={rowData} onDeleteCallback={onDeleteCallback} />
    </div>
  );

  return (
    <CustomDataTable value={roadMaps} dataKey="idRoadmap" rows={15} loading={isLoading}>
      {(isLoggedIn && <Column headerStyle={{ width: '8rem' }} body={actionBodyTemplate} />) as JSX.Element}
      {children}
    </CustomDataTable>
  );
};

export default RoadmapTable;
